(function() {
    'use strict';

    angular
        .module('TR')
        .service('v2v3HandoverService', v2v3HandoverService);

    function v2v3HandoverService($location) {
        const service = {
            redirectEstabLandingPath,
            redirectDestLandingPath,
            isV2Request,
            redirectLoginPaths
        };

        function isV2Request() {
            return $location.search().gov && $location.search().gov === '2';
        }

        function redirectLoginPaths(path) {
            const isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
            const enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');

            // exit if redirect not enabled
            if (isAgentMode || !enableV3SignIn) {
                return false;
            }

            const loginPaths = ['/signin', '/signup', '/v3'];
            const pathLowerCase = path && path.toLowerCase();
            const matchedPath = loginPaths && loginPaths.find(pathname => pathname === pathLowerCase);
            // exit if redirect not enabled
            if (!matchedPath) {
                return false;
            }

            return matchedPath;
        }

        function redirectEstabLandingPath(path) {
            // exit if redirect not enabled
            if (!_.get(TRPCONFIG, 'Domain2.UseV3HotelEstabPage')) {
                return false;
            }
            const res = path.match(/\/2-\d*(\/|-1\/)/);
            // exit if no regex match
            if (!res) {
                return false;
            }

            const exceptions = _.get(TRPCONFIG, 'Domain2.V3HotelEstabPageExceptions');
            // return false is this an excluded estab, else true.
            return !exceptions.find(id => id === parseInt(res[1]));
        }

        function redirectDestLandingPath(path) {
            // exit if redirect not enabled
            if (!_.get(TRPCONFIG, 'Domain2.UseV3LandingPage')) {
                return false;
            }
            const res = path.match(/\/1-([0-9]{1,5})-[1-2]{1}-0\//);
            // exit if no regex match
            if (!res) {
                return false;
            }

            const sitemap = path.match(/sitemap\//);
            // exit if actually a V2 sitemap page
            if (sitemap) {
                return false;
            }

            const exceptions = _.get(TRPCONFIG, 'Domain2.V3LandingPageExceptions');
            // return false is this an excluded dest, else true.
            return !exceptions.find(id => id === parseInt(res[1]));
        }

        return service;
    }
})();
